import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BuildingEnergyModelFragment } from '../../generated/graphql'
import { BuildingEnergyModelDrawer } from './drawer/BuildingEnergyModelDrawer'
import { formatArea } from '../../util/formatters'

type Props = {
  buildingEnergyModels: BuildingEnergyModelFragment[]
}

export function BuildingEnergyModelsList({
  buildingEnergyModels,
}: Props): React.ReactElement {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [modelId, setModelId] = useState<string>()

  const { t } = useTranslation()

  const onDrawerClose = () => {
    setIsDrawerOpen(false)
  }

  const onEnergyModelClick = (id: string) => {
    setModelId(id)
    setIsDrawerOpen(true)
  }

  const buildingEnergyModel = buildingEnergyModels.find(
    ({ id }) => id === modelId,
  )

  return (
    <Box width="100%">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width="60%">
                {t('buildingEnergyModels.name')}
              </TableCell>
              <TableCell>{t('building.tabs.common.buildingType')}</TableCell>
              <TableCell>{t('unitName.area')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {buildingEnergyModels.map((model) => (
              <TableRow
                key={model.id}
                hover
                onClick={() => onEnergyModelClick(model.id)}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>{model.name}</TableCell>
                <TableCell>{t(`buildingType.${model.type}`)}</TableCell>
                <TableCell>{formatArea(model.area)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {buildingEnergyModel && (
        <BuildingEnergyModelDrawer
          isOpen={isDrawerOpen}
          onClose={onDrawerClose}
          energyModel={buildingEnergyModel}
        />
      )}
    </Box>
  )
}
